import { create } from "zustand";
import { devtools, subscribeWithSelector } from "zustand/middleware";
import type { WidgetStore } from "@/state";
import {
  createStateSlice,
  createUiSlice,
  createActionsSlice,
  createChatbotSlice,
} from "@/state/slices";

export const useWidgetStore = create<WidgetStore>()(
  devtools(
    subscribeWithSelector((...a) => ({
      ...createStateSlice(...a),
      ...createActionsSlice(...a),
      ...createUiSlice(...a),
      ...createChatbotSlice(...a),
    })),
    { name: "telekomId-widget" },
  ),
);
